import React from "react";
import PropTypes from "prop-types";
import PercentChanged from "../percentChanged/percentChanged";
import { Tooltip } from "react-tooltip";
import { asNumberString } from "../../utils/formatters";
import UserAvatar from "../../components/userAvatar/userAvatar";
import "./profileStatsBlock.scss";

function ProfileStatsBlock(props) {
  /**
   * TODO: Props currently mock data. Needs to be replaced
   * with defaults.
   *
   * TODO: Colors need to be programmatically generated
   */
  props = {
    bigPercentToolTip: "Class Utilization",
    ...props
  };

  if (props.data.length > 0) {
    const data = {
      firstName: props.data[props.index].firstName,
      lastName: props.data[props.index].lastName,
      attendancePercentage: props.data[props.index].percentage,
      totalAttendees: props.data[props.index].totalAttendees,
      totalPotentialAttendees: props.data[props.index].totalPotentialAttendees,
      percentChange: props.data[props.index].percentChange,
      newAttendees: props.data[props.index].newAttendees,
      topClasses: props.data[props.index].topClasses,
      userImg: props.data[props.index].imageUrl
    };

    const truncateName = (firstName, lastName) => {
      return `${firstName} ${lastName.charAt(0) + "."}`;
    };

    return (
      <div
        className={
          !props.topPerformer ? "profile-stats-container" : "profile-stats-container-background"
        }
      >
        <h2 className="profile-stats-name">{truncateName(data.firstName, data.lastName)}</h2>
        <div className="profile-stats-grid">
          {data.userImg !== "" ? (
            <img className="profile-stats-image" src={data.userImg} />
          ) : (
            <UserAvatar firstName={data.firstName} lastName={data.lastName} />
          )}
          <div className="profile-stats-attendance">
            <h5 className="profile-stats-title">Attendance</h5>
            <p
              data-tooltip-content={props.bigPercentToolTip}
              data-tooltip-id="profile-stat-tooltip"
              className="profile-stats-attendance__percentage"
            >
              {Math.round(data.attendancePercentage * 100)}%
            </p>
            <div>
              <p className="profile-stats-attendance__number">
                {asNumberString(data.totalAttendees)} of{" "}
                {asNumberString(data.totalPotentialAttendees)}
              </p>
            </div>
            <div className="profile-stats-attendance__percent">
              <PercentChanged
                changeValue={data.percentChange}
                showBorder
                toolTip="Attendance change from previous month"
              />
            </div>
          </div>
        </div>
        {props.topPerformer && (
          <div className="profile-stats-second-row">
            <div className="profile-stats-new-attendees">
              <h5 className="profile-stats-title">New Attendees</h5>
              <p className="profile-stats-new-attendees__number">{data.newAttendees}</p>
            </div>
            <div className="profile-stats-top-classes">
              <h5
                data-tooltip-content="Ranked by Headcount"
                data-tooltip-id="profile-stat-tooltip"
                className="profile-stats-title"
              >
                Top Classes
              </h5>
              <ul className="profile-stats-top-classes__list">
                {data.topClasses.map((classProps) => {
                  return (
                    <li key={classProps.id} className="profile-stats-top-classes__item">
                      {classProps.name}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
        <Tooltip id="profile-stat-tooltip" float />
      </div>
    );
  } else {
    return null;
  }
}

export default ProfileStatsBlock;

ProfileStatsBlock.propTypes = {
  index: PropTypes.number,
  data: PropTypes.any,
  topPerformer: PropTypes.bool,
  bigPercentToolTip: PropTypes.string
};
